import Button from '@react/react-spectrum/Button';
import Link from '@react/react-spectrum/Link';
import Wait from '@react/react-spectrum/Wait';
import CheckmarkCircle from '@react/react-spectrum/Icon/CheckmarkCircle';
import Alert from '@react/react-spectrum/Icon/Alert';
import LinkOut from '@react/react-spectrum/Icon/LinkOut';
import InfoOutline from '@react/react-spectrum/Icon/InfoOutline';
import Tooltip from '@react/react-spectrum/Tooltip';
import OverlayTrigger from '@react/react-spectrum/OverlayTrigger';

import { getLivedemosWorkspacesUrl } from 'services/environment';
import { LIVEDEMOS_STATUS } from './useLivedemosStep';

export const LivedemosProgress = ({
  status,
  workspaceId,
  error,
  reusedExistingWorkspace = false
}) => {
  const livedemosUrl = workspaceId
    ? `${getLivedemosWorkspacesUrl()}/workspaces/${workspaceId}`
    : null;

  return (
    <div className="jobs-progress">
      <div className="job">
        <div className="overview">
          <span className="job-icon">
            {status === LIVEDEMOS_STATUS.IDLE && (
              <span className="pending-icon" />
            )}
            {status === LIVEDEMOS_STATUS.IN_PROGRESS && <Wait size="S" />}
            {status === LIVEDEMOS_STATUS.SUCCESS && (
              <CheckmarkCircle className="success" size="S" />
            )}
            {status === LIVEDEMOS_STATUS.ERROR && (
              <Alert className="success-with-errors" size="S" />
            )}
          </span>
          <span className="job-title">Livedemos Workspace</span>
          {status === LIVEDEMOS_STATUS.ERROR && (
            <div className="job-info">
              <OverlayTrigger placement="right">
                <Button
                  variant="tool"
                  icon={<InfoOutline size="XS" />}
                  aria-label="What to do if livedemos workspace setup fails"
                />
                <Tooltip className="livedemos-tooltip">
                  <p>
                    This is a separate step that does not affect the Demo System
                    Next configuration. However, if you still want to use the
                    Live Demos functionalities like assets, branding, or product
                    scraping, please:
                  </p>
                  <ul>
                    <li>Refresh the page and try starting quick-setup again</li>
                    <li>
                      Go to the{' '}
                      <Link
                        href={`${new URL(getLivedemosWorkspacesUrl()).origin}`}
                        target="_blank"
                        rel="noreferrer noopener">
                        Livedemos Platform
                      </Link>{' '}
                      and create an empty workspace manually
                    </li>
                  </ul>
                </Tooltip>
              </OverlayTrigger>
            </div>
          )}
        </div>

        {status === LIVEDEMOS_STATUS.SUCCESS && livedemosUrl && (
          <div className="job-details">
            <div>
              {reusedExistingWorkspace
                ? 'Demo registered in the Live Demos workspace already linked to this DSN workspace.'
                : 'Live Demos workspace created and demo registered.'}
            </div>
            <div className="links">
              <a
                href={livedemosUrl}
                className="spectrum-Link"
                target="_blank"
                rel="noreferrer noopener">
                Open in Livedemos <LinkOut size="XS" />
              </a>
            </div>
          </div>
        )}

        {status === LIVEDEMOS_STATUS.ERROR && (
          <div className="job-details">
            <div>Failed to setup livedemos workspace: {error}</div>
          </div>
        )}
      </div>
    </div>
  );
};
